export const START_HOUR = 8;
export const START_MINUTE = 0;

export const CELL_DURATION = 30;

export const DAY_HOURS = 12; // 08:00 - 20:00 = 12 hours
export const DAY_CELLS = (DAY_HOURS + 1) * (60 / CELL_DURATION); // from 08:00 up to 20:30 = 26 cells 30 minutes each

export const DEFAULT_TIMEZONE = 'Europe/Berlin';
